<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" />
    <form>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">选择缴费方式：</span>
        </div>
        <el-select
          v-model="paymentCode"
          filterable
          remote
          reserve-keyword
          placeholder="请选择缴费方式"
          size="mini" style="width:280px"
          :remote-method="paymentRemoteMethod"
           >
           <el-option
            v-for="item in paymentList"
            :key="item.code"
            :label="item.paymentCycleName"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费金额：</span>
        </div>
        <el-input v-model="formData.money" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="formData.paymentCode==='testppc83770871'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位号：</span>
        </div>
        <el-input v-model="formData.lotNumber" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="formData.carNumber" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="formData.carOwnerName" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">起始时间：</span>
        </div>
       <el-date-picker v-model="reqData.enterStartDate" disabled type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="changeEnterStartDate()" style="width:280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">结束时间：</span>
        </div>
       <el-date-picker v-model="reqData.enterEndDate" disabled type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="small" @change="changeEnterEndDate()" style="width:280px"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款时间：</span>
        </div>
          <el-date-picker
            style="width:280px"
            v-model="reqData.payTime"
            value-format="yyyy-MM-dd hh:mm:ss"
            type="datetime"
            placeholder="选择收款时间"
            align="right">
          </el-date-picker>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/ParkingService";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "monthly-vehicle-renew",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月车辆"
        }
      ],
      mainTitle: "续费包月车辆",
      formData: {
        code: "",
        lotNumber: "",
        enterStartDate: "",
        enterEndDate: "",
        carNumber: ""
      },
      reqData: {
        code: "",
        paymentMethod: "",
        money: "",
        carNumber: "",
        carOwnerName: "",
        enterStartDate: "",
        enterEndDate: "",
        lotCode: ""
      },
      paymentCode: "",
      responsiblePersonList: [],
      paymentList: []
    };
  },
  created() {
    // let date = new Date();
    // let year = date.getFullYear();
    // let month = date.getMonth() + 1;
    // let strDate = date.getDate();

    // if (month >= 1 && month <= 9) {
    //   month = "0" + month;
    // }
    // if (strDate >= 0 && strDate <= 9) {
    //   strDate = "0" + strDate;
    // }

    // let oneYearLateYear = year + 1;
    // let oneYearLateMonth = month;
    // let oneYearLateDate = "";
    // if (strDate > 1) {
    //   oneYearLateDate = strDate - 1;
    // } else {
    //   oneYearLateMonth = month - 1;
    //   if (oneYearLateMonth < 10) {
    //     oneYearLateMonth = "0" + oneYearLateMonth;
    //   }
    //   if (oneYearLateMonth === 0) {
    //     oneYearLateMonth = 12;
    //     oneYearLateYear = year;
    //   }
    //   oneYearLateDate = new Date(
    //     oneYearLateYear,
    //     oneYearLateMonth,
    //     0
    //   ).getDate();
    // }
    // if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
    //   oneYearLateDate = "0" + oneYearLateDate;
    // }
    // this.reqData.enterStartDate = `${year}-${month}-${strDate}`;
    // this.reqData.enterEndDate = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;

    this.formData.code = this.$route.params.id;
    this.reqData.code = this.$route.params.id;
    this.getMonthlyVehicleByCode();
    this.paymentRemoteMethod();
  },
  mounted() {
    this.changePickerOptions1();
  },
  methods: {
    toMonthlyVehiclePage() {
      this.$router.push({
        name: "monthly-vehicle"
      });
    },
    changePickerOptions1() {
      let enterStartDateTime =
        new Date(this.formData.enterStartDate).getTime() - 3600 * 24 * 1000;
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < enterStartDateTime;
        }
      };
      this.changeTime();
    },
    changePickerOptions2() {
      let enterEndDateTime = new Date(this.reqData.enterEndDate).getTime();
      this.pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() > enterEndDateTime;
        }
      };
    },
    changeEnterStartDate() {
      this.changePickerOptions1();
    },
    changeEnterEndDate() {
      this.changePickerOptions2();
    },
    getMonthlyVehicleByCode() {
      this.$axios
        .get(`${api.getMonthlyVehicleByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
            console.log(this.formData);
            this.reqData.carNumber = res.data.data.carNumber;
            this.reqData.carOwnerName = res.data.data.carOwnerName;
            this.reqData.lotCode = res.data.data.lotCode;

            let date = new Date(this.formData.enterEndDate);
            let startTime = date.getTime() + 86400000;
            let d1 = new Date(startTime);
            this.reqData.enterStartDate = `${d1.getFullYear()}-${
              d1.getMonth() + 1 < 10
                ? "0" + (d1.getMonth() + 1)
                : d1.getMonth() + 1
            }-${d1.getDate() < 10 ? "0" + d1.getDate() : d1.getDate()}`;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    paymentRemoteMethod(query) {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          searchKey: query,
          configType: 2
        })
        .then(res => {
          if (res.data.retCode === 1) {
            // console.log(res);
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleName = "月付";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleName = "季付";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleName = "半年付";
              } else if (v.paymentCycle === "4") {
                v.paymentCycleName = "年付";
              }
            });
            this.paymentList = data;
            // console.log(this.paymentList);
          }
        })
        .catch(errorHandler("获取缴费列表失败"));
    },
    confirm() {
      if (!this.reqData.money) {
        nError("请选择缴费方式");
        return false;
      }
      if (!this.reqData.enterStartDate) {
        nError("请选择起始日期");
        return false;
      }
      if (!this.reqData.enterEndDate) {
        nError("请选择结束日期");
        return false;
      }
      if (!this.reqData.payTime) {
        nError("请选择收款时间");
        return false;
      }
      this.$axios
        .post(api.MonthlyVehicleRenew, this.reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("续费成功");
            this.toMonthlyVehiclePage();
          }
        })
        .catch(errorHandler("续费失败"));
    },
    cancel() {
      this.toMonthlyVehiclePage();
    },

    changeTime() {
      if (this.reqData.paymentMethod == "1") {
        let nowDate = new Date(this.reqData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let YYYY = "";
        let MM = "";
        let DD = "";
        if (mm == 12) {
          if (dd == '01') {
            MM = mm
            YYYY = yyyy;
          } else {
            MM = "01"
            YYYY = yyyy + 1;
          }
        }  else {
          YYYY = yyyy;
          if (dd == '01') {
            MM = +mm < 10 ? "0" + (+mm) : +mm;
          } else {
            MM = +mm + 1 < 10 ? "0" + (+mm + 1) : +mm + 1;
          }
        }
        if (dd == "01") {
          if (mm == "01" || mm == "03" || mm == "05" || mm == "07" || mm == "08" || mm == "10" || mm == "12") {
            DD = "31";
            MM = +mm < 10 ? "0" + +mm : +mm;
          } else if (mm == "02") {
            if (yyyy % 4 == 0 || yyyy % 400 == 0) {
              DD = "29";
            } else {
              DD = "28";
            }
          } else {
            DD = "30";
          }
        } else {
          DD = dd - 1;
        }
        if ((mm == "01" && dd == "31" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        } else if (mm == "01" && dd == "31" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "02";
        }
        if ((mm == "01" && dd == "30" && yyyy % 4 == 0) || yyyy % 400 == 0) {
          YYYY = yyyy;
          MM = "02";
          DD = "29";
        } else if (mm == "01" && dd == "30" && yyyy % 4 != 0) {
          YYYY = yyyy;
          MM = "03";
          DD = "01";
        }
        DD = DD < 10 ? "0" + DD : DD;
        let enterEndDate = `${YYYY}-${MM}-${DD}`;
        this.reqData.enterEndDate = enterEndDate;
      } else if (this.reqData.paymentMethod == "2") {
        let nowDate = new Date(this.reqData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 3);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.reqData.enterEndDate = enterEndDate;
      } else if (this.reqData.paymentMethod == "3") {
        let nowDate = new Date(this.reqData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 6);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.reqData.enterEndDate = enterEndDate;
      } else if (this.reqData.paymentMethod == "4") {
        let nowDate = new Date(this.reqData.enterStartDate);
        let yyyy = nowDate.getFullYear();
        let mm =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        let dd =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        let enterStartDate = `${yyyy}-${mm}-${dd}`;
        let dt = new Date(yyyy, mm - 1, dd);
        dt.setMonth(dt.getMonth() + 12);
        dt.setDate(dt.getDate() - 1);
        let yyyy2 = dt.getFullYear();
        let mm2 =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : dt.getMonth() + 1;
        let dd2 = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        let enterEndDate = `${yyyy2}-${mm2}-${dd2}`;
        this.reqData.enterEndDate = enterEndDate;
      }
    }
  },
  watch: {
    paymentCode(val) {
      this.paymentList.map(v => {
        if (v.code === val) {
          console.log(v);
          this.formData.paymentCode = v.code;
          this.formData.money = v.unitPrice;
          this.formData.paymentMethod = v.paymentCycle;
          this.reqData.paymentCode = v.code;
          this.reqData.money = v.unitPrice;
          this.reqData.paymentMethod = v.paymentCycle;
          this.changeTime();
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/MonthlyVehicle/MonthlyVehicleRenew.vue